<template>
    <div class="tab_lecture_cont">
        <loading :active.sync="isLoading" :can-cancel="true"></loading>
        <!-- 강좌 찾아보기 -->
        <div class="find_wrap_course" v-if="withSubject === true">
            <div class="tit">강좌 찾아보기</div>
            <!-- 과목선택 -->
            <div class="choice_subject">
                <div class="tit_sub">{{categoryTitle}}</div>
                <slot name="subject">
                    <ul>
                        <li v-for="row in subjectList" :class="subjectCategoryId == row.store_category_id ? 'on' : ''" @click="getLectureListByCategoryId(row.store_category_id)">{{row.category_name}}</li>
                    </ul>
                </slot>
            </div>
            <!-- // 과목선택 -->
            <div class="per_subject">
            </div>
        </div>
        <!-- // 강좌 찾아보기 -->
        <online-lecture-list :lecture-info="lectureInfo"  :width-css="widthCss"  :double-info="doubleInfo" :category-id=categoryId :pay-buttons=payButtons :is-membership-lectures=isMembershipLectures></online-lecture-list>
    </div>
</template>

<script>
import Axios from 'axios';
import Loading from 'vue-loading-overlay';

import OnlineLectureList from './online-lecture-list';


export default {
  props: {
    withSubject: { type: Boolean, default: true },
    randSubject: { type: Boolean, default: true },
    doubleInfo: { type: Boolean, default: true },
    payButtons: {type: Boolean, default: true },
    multiplePlayPopup: {type: Boolean, default: true  },
    isMembershipLectures: {type: Boolean, default: false },
    widthCss: { type: String, default: 'w960' },
    saleinfoIds: { type: String, default: null },
    paymentSetting: {type: String, default: 'myclass.dangi.co.kr'},
    initCategory: { type: String, default: null },
    categoryTitle: { type: String, default: '과목선택' },
    tags: { type: String, default: null },
  },
  name: 'online-lecture-landing',
  created() {
    if (typeof payment_setting === 'function') {
      payment_setting({domain : this.paymentSetting});
    } else {
      console.log('결제 라이브러리 호출 실패');
    }

    if (this.initCategory !== null) {
      this.getSubjectListByCategoryId(this.initCategory);
    }

    if (this.saleinfoIds !== null) {
      this.getLectureListBySeleinfoIds(this.saleinfoIds);
    }

    this.$EventBus.$on('getSubjectList', this.getSubjectListByCategoryId);
    this.$EventBus.$on('getLectureList', this.getLectureListBySeleinfoIds);
    this.$EventBus.$on('getLectureListByCategoryId', this.getLectureListByCategoryId);
  },
  data() {
    return {
      categoryId: NaN,
      isLoading: false,
      subjectCategoryId: NaN,
      subjectList: [],
      lectureInfo: {},
    };
  },
  methods: {
    getSubjectListByCategoryId(categoryId) {
      this.categoryId = parseInt(categoryId, 10);
      this.isLoading = true;
      Axios.get(`/gong/lecture/lecture_ajax/ax_get_SubjectList/${categoryId}`).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true && response.data.result.length > 0) {
          this.subjectList = response.data.result;
          let callSubject = 0;
          if (this.randSubject === true && this.subjectList.length > 2) {
            callSubject = Math.floor((Math.random() * 3));
          }

          this.getLectureListByCategoryId(this.subjectList[callSubject].store_category_id);
        } else {
          this.isLoading = false;
          this.subjectCategoryId = NaN;
          this.subjectList = [];
        }
      });
    },
    getLectureListByCategoryId(subjectCategoryId) {
      this.subjectCategoryId = parseInt(subjectCategoryId, 10);
      this.isLoading = true;
      const callUrl = this.makeCallUrl(`/gong/lecture/lecture_ajax/ax_get_LectureListByCategoryId/${this.subjectCategoryId}`);

      Axios.get(callUrl).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true) {
          const nowResult = response.data.result;
          this.lectureInfo = {};
          if (Object.prototype.hasOwnProperty.call(nowResult.teacherLectureList, 'length') === true && nowResult.teacherLectureList.length > 0) {
            this.lectureInfo = nowResult;
          }
        } else {
          this.lectureInfo = {};
        }

        this.isLoading = false;
      });
    },
    getLectureListBySeleinfoIds(saleinfoIds) {
      this.isLoading = true;
      const callUrl = this.makeCallUrl(`/gong/lecture/lecture_ajax/ax_get_LectureListBySaieinfoIds?saleinfoIds=${saleinfoIds}`);

      Axios.get(callUrl).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result') === true) {
          const nowResult = response.data.result;
          this.lectureInfo = {};
          if (Object.prototype.hasOwnProperty.call(nowResult.teacherLectureList, 'length') === true && nowResult.teacherLectureList.length > 0) {
            this.lectureInfo = nowResult;
          }
        } else {
          this.lectureInfo = {};
        }

        this.isLoading = false;
      });
    },
    makeCallUrl(baseUrl) {
      let callUrl = baseUrl;
      const addParams = [];
      if (this.isMembershipLectures == true) {
        addParams.push('isMembershipLectures=Y');
      }
      if (this.tags !== null && this.tags.length > 1) {
        addParams.push(`tags=${this.tags}`);
      }

      if (addParams.length > 0) {
        const paramsStr = addParams.join('&');
        callUrl += `?${paramsStr}`;
      }

      return callUrl;
    },
  },
  components: {
    Loading,
    'online-lecture-list': OnlineLectureList,
  },
};
</script>



// WEBPACK FOOTER //
// src/Lecture/components/online-lecture-landing.vue